// Initialise à « P » la taille (member) des organisations de type association
// qui n'en ont pas. Les organisations ayant déjà une taille sont ignorées.

import {memberObjects} from "../staticEntities";

const SMALL_MEMBER_ID = memberObjects.find(member => member.name === 'P').id

async function applyJob() {
    const result = await global.app.C.Organization.collection.updateMany(
        // {$in: [null]} couvre aussi le champ absent
        {organizationType: 'association', member: {$in: [null, '']}},
        {$set: {member: SMALL_MEMBER_ID}}
    )
    return {message: `${result.modifiedCount} association(s) initialisée(s) avec la taille « P »`}
}

export const job = {
    name: "initAssociationsMemberSize",
    title: "Initialiser la taille des associations sans taille (P)",
    execute: function(context, callback) {
        applyJob()
            .then(result => callback(null, result))
            .catch(callback)
    }
}